import React from 'react';
import { Switch, Text, View, ViewStyle } from 'react-native';
import { COLORS } from '../constants/theme';

interface OwnershipScopeToggleProps {
  ownershipScope: 'group' | 'self';
  onOwnershipScopeChange?: (value: 'group' | 'self') => void;
  labelColor?: string;
  thumbColorOn?: string;
  containerStyle?: ViewStyle;
}

export const OwnershipScopeToggle: React.FC<OwnershipScopeToggleProps> = ({
  ownershipScope,
  onOwnershipScopeChange,
  labelColor = '#374151',
  thumbColorOn = COLORS.primary,
  containerStyle,
}) => {
  return (
    <View style={[{ flexDirection: 'row', alignItems: 'center', gap: 6 }, containerStyle]}>
      <Switch
        value={ownershipScope === 'self'}
        onValueChange={(value: boolean) => onOwnershipScopeChange?.(value ? 'self' : 'group')}
        trackColor={{ false: '#D1D5DB', true: '#BFDBFE' }}
        thumbColor={ownershipScope === 'self' ? thumbColorOn : '#FFFFFF'}
      />
      <Text style={{ color: labelColor, fontWeight: '600', fontSize: 12 }}>
        {ownershipScope === 'self' ? 'Only mine' : 'Group'}
      </Text>
    </View>
  );
};
